import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MenuHighlights from './components/MenuHighlights';
import AboutUs from './components/AboutUs';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Specials from './components/Specials';
import Location from './components/Location';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <div className="App">
      <Navbar scrolled={scrolled} />
      <Hero />
      <MenuHighlights />
      <AboutUs />
      <Testimonials />
      <Gallery />
      <Specials />
      <Location />
      <ContactForm />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
